import { type PasswordConfig } from '../../shared/types';

/** An Error with multiple messages */
export class MultiMessageError extends Error {
  public messages?: string[];

  constructor(messages: string[]) {
    super(messages.join('\n'));
    this.messages = messages;
  }
}

/** The results of validating a password */
export interface ValidationResults {
  pass: (keyof PasswordConfig)[];
  fail: (keyof PasswordConfig)[];
  skip: (keyof PasswordConfig)[];
}
